// extracted by mini-css-extract-plugin
export default {"header":"index_header__Tqfcu","modaltitle":"index_modaltitle__89QVi","beautifystyle":"index_beautifystyle__Yr0kc","switch":"index_switch__4Ml5j"};